@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field class='pb-4' [appearance]='inputService.inputConfig.appearence'>
      @if (inputService.formInputDefinition.remoteOptions.icon) {
        <mat-icon matPrefix class='mr-4'>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
      }
      <mat-label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <ng-container [formGroup]="inputService.formGroup">
        <input
          matInput
          [required]='inputService.inputConfig.required'
          type='text'
          autocomplete="off"
          [name]='inputService.formControlKey'
          (focusout)='onFocusOut()'
          (blur)='onFocusOut()'
          [readonly]='inputService.inputConfig.readOnly || optionSelected'
          [placeholder]="(inputService.inputConfig.placeholder || '') | translate"
          [matAutocomplete]="auto"
          [formControl]='inputFormControl'
          [value]='displayValue'
          (input)='fetchFilteredOptions($event.target.value)'>
      </ng-container>
      @if (optionSelected && !inputService.inputConfig.readOnly) {
        <button mat-icon-button matSuffix (click)='selectDatasetOption(null); textSearch = null;'>
          <span class="material-icons">{{'close' | translate}}</span>
        </button>
      }
      @if (loading) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (creatingNew) {
        <mat-hint>{{ (inputService.formInputDefinition.remoteOptions.createHint || "Verrà creato un nuovo record") | translate }}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
      <input type='hidden' [formControlName]='inputService.formControlKey' />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)='selectDatasetOption($event.option.value)'>
        @if (supportCreate && textSearch) {
          <mat-option [value]="textSearch" (click)='emitEventOnSupportCreation($event)'>
            <mat-icon>add</mat-icon>
            <span>{{'Crea' | translate}}: {{textSearch}}</span>
          </mat-option>
        }
        @for (option of filteredOptions | async; track trackByOptions($index, option)) {
          <mat-option [value]="option">
            @if (inputService.formInputDefinition.remoteOptions.icon) {
              <mat-icon>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
            }
            <span [innerHTML]='inputService.formInputDefinition.remoteOptions.getLabel(option)'></span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
}